import SelfServeLoading from "./components/checkouts/webstore/pages/self-serve-loading";
import Webstore from "./components/checkouts/webstore/pages/webstore";
import ReviewCart from "./components/checkouts/webstore/pages/review-cart";
import ShippingPage from "./components/checkouts/checkout/pages/shipping";
import ReviewPage from "./components/checkouts/checkout/pages/review";
import PaymentPage from "./components/checkouts/checkout/pages/payment";
import ConfirmPage from "./components/checkouts/checkout/pages/confirm";
import ConfirmRenewalPage from "./components/checkouts/checkout/pages/confirm-renewal";
import ClientMessage from "./components/utils/pages/client-message";

export const routes = [
  {
    path: "/webstore/loading",
    component: SelfServeLoading,
    name: "Small Fleet Loading",
  },
  { path: "/webstore", component: Webstore, name: "Product Catalog" },
  { path: "/review-cart", component: ReviewCart, name: "Review Cart" },
  { path: "/checkout/shipping", component: ShippingPage, name: "Shipping" },
  { path: "/checkout/review", component: ReviewPage, name: "Review" },
  { path: "/checkout/payment", component: PaymentPage, name: "Payment" },
  { path: "/checkout/confirm", component: ConfirmPage, name: "Confirm" },
  {
    path: "/checkout/confirm-renewal",
    component: ConfirmRenewalPage,
    name: "Confirm Renewal",
  },
  { path: "/message", component: ClientMessage, name: "Client Message" },
  {
    path: "/checkout/payment-update",
    component: PaymentPage,
    name: "Payment Update",
  },
];
